var ServiceWorkerMixin = {
  methods: {
    $_ServiceWorkerMixin_sendMessage(type) {
      var _navigator$serviceWor, _navigator$serviceWor2;

      if (!this.$store.state.serviceWorkerReady) {
        console.log('[ServiceWorkerMixin] Service worker is not ready...');
        return;
      }

      console.log('[ServiceWorkerMixin] postMessage: ', type);
      (_navigator$serviceWor = navigator.serviceWorker) === null || _navigator$serviceWor === void 0 ? void 0 : (_navigator$serviceWor2 = _navigator$serviceWor.controller) === null || _navigator$serviceWor2 === void 0 ? void 0 : _navigator$serviceWor2.postMessage({
        type
      });
    }

  }
};
export default ServiceWorkerMixin;